import * as AllSentry from '@sentry/nextjs'

export const Sentry = AllSentry
